import { useEffect } from 'react';
import { abilityConfig } from 'config/ability';

import { useForceUpdate } from 'hooks';

const Feature = ({ passThrough, not, children, ...props }) => {
  const forceUpdate = useForceUpdate();

  useEffect(() => {
    const unsubscribeFromAbility = abilityConfig.on('updated', () => {
      forceUpdate();
    });

    return () => {
      unsubscribeFromAbility();
    };
  }, [forceUpdate]);

  const isAllowed = () => {
    const [action, field] = (props.is || props.in).split(/\s+/);
    const subject = props.do || props.name;
    const can = not ? 'cannot' : 'can';

    return abilityConfig[can](action, subject, field);
  };

  return passThrough || isAllowed() ? children : null;
};

export default Feature;
